import React, { Component } from 'react';
class VerifyCodeContent extends React.Component {
    
    constructor(props) {
        super(props)
        this.state = this.defaultProps(props)
        
        this.getCurrentDateTime         = this.getCurrentDateTime.bind(this);
        this.createVerifyCode           = this.createVerifyCode.bind(this);
    }

    defaultProps(props) {
        return { 
            tables: [],
            orders: [],
            verifyCode: null,
            selectedVoucher: null
        }
    }
    
    componentDidMount() {
        this.getCurrentDateTime();

        if(!this.props.app.state.verifyCode){
            this.createVerifyCode();
        }
    }

    updateDataStatus(voucher){
        if(voucher == null){
            return;
        }

        $.ajax({
            url     : `/verifycode/updatevouchershowflag`,
            type    : 'post',
            data    : {
                voucher_id       : voucher.id,
                show             : "true"
            },
            success : (response) => {
                console.log(response)
            }
        }).fail(ajaxFails)
    }

    resetPage(message){
        let voucher = this.props.app.state.selectedVoucher
        let music = document.getElementById("sound");
        if(!music.paused){
            music.pause()
            $("#sound").hide();
        }

        clearInterval(message);

        this.updateDataStatus(voucher)

        this.props.app.setState({
            selectedVoucher: null
        })
    }

    showMessage(){
        let me = this

        if(!this.props.app.state.table){
            return;
        }

        let voucher = this.props.app.state.selectedVoucher
        let table = this.props.app.state.table

        $("#code-frame").fadeOut()
        $('#table-name').text(table.name + " ")
        $('#voucher-desc').text(voucher.voucher_desc)

        //MP3
        // let audio = new Audio('congratulation.mp3');
        let music = document.getElementById("sound");
        if(music.paused){
            var promise = music.play();
            if (promise !== undefined) {
                promise.then(_ => {
                    // Autoplay started!
                }).catch(error => {
                    // Autoplay was prevented.
                    // Show a "Play" button so that user can start playback.
                    music.setAttribute("controls", "controls")
                });
            }
        }

        $("#sound").hide();
        $("#message-frame").fireworks();
        $("#message-frame").fireworks('destroy');
        
        // var flash = setInterval(function(){
        //     me.resetPage();
        // }, 8000) 

        // $("#message-frame").fadeOut(8000);
        // $("#code-frame").fadeIn(8000);

        var message = setInterval(function(){
            me.resetPage(message);
        }, 8000) 

        return (
            <div id="message-frame">
                <h3 style={{textAlign:"center", fontSize:"80px"}}>{lang.congratulation.toString()}</h3>
                <h3 style={{textAlign:"center", fontSize:"80px"}}>
                    {lang.table.toString()} <span style={{textAlign:"center", fontSize:"80px", color: "blue"}}>{table.name + " "}</span> 
                    {lang.get.toString()} <span style={{textAlign:"center", fontSize:"120px", color: "red"}}>{voucher.voucher_desc}</span> 
                </h3>
            </div>
        )
    }

    createVerifyCode(){
        window.$.ajax({
            url     : "/verifycode/updatecode",
            type    : 'post',
            data    : {
                merchant_id      : "Please Change to Real merchant id"//"c223d6bd-97bf-4ab3-8c64-43095447871d"
            },
            success : (response) => {
                this.forceUpdate();
                console.log(response)
            }
        })
    }

    formatNumber(number){
        if(number > 9)
            return number.toString();
        else
            return "0" + number.toString();
    }

    getCurrentDateTime(){
        let today = new Date()
        let time = today.getFullYear().toString() + "-" + this.formatNumber(today.getMonth() + 1) + "-" + this.formatNumber(today.getDate()) + 
            " " + this.formatNumber(today.getHours()) +  ":" + this.formatNumber(today.getMinutes());// + ":" + this.formatNumber(today.getSeconds());

        this.setState({
            currentDT: time
        })
    }

    getVerifyCode(){
        let me = this;

        // var second = setInterval(function(){
        //     me.getCurrentDateTime(true, second);
        // }, 1000) 

        var minute = setInterval(function(){
            me.getCurrentDateTime();
        }, 60000) 
        
        return (
            <div id="code-frame">
                <h3 style={{textAlign:"center", fontSize:"60px"}}>{lang.today_code}</h3>
                <h3 style={{textAlign:"center", fontSize:"60px"}}>{this.state.currentDT}</h3>
                <span style={{display:"block", textAlign:"center", fontSize:"150px"}} >{this.props.app.state.verifyCode}</span>
            </div>
        )
    }

    render() {
        return (
            <div>
                <div>
                    {this.props.app.state.selectedVoucher? null : this.getVerifyCode()}
                    {this.props.app.state.selectedVoucher? this.showMessage() : null}
                </div>

                <audio id="sound" style={{position:"absolute", left:"25%"}}>
                    <source src="../resources/assets/mp3/congratulation.mp3" type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>
            </div>
        ) 
    }
}

export default VerifyCodeContent;

var VerifyCodeBody = {
    show: function() {
        ReactDOM.render(
            <VerifyCodeContent />,
            $('#react-app')[0]
        )
    }
}